define( [
	"./arr"
], function( arr ) {
	return arr.slice;
} );



//////////////////
// WEBPACK FOOTER
// ./~/jquery/src/var/slice.js
// module id = 79
// module chunks = 0